<template>
  <div v-show="tableDisplay == 'document_categories'">
    <v-row style="margin-top: -83px">
      <v-spacer></v-spacer>
      <v-col cols="3" class="text-right"> 
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details>
          <template slot="append-outer">
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row class="mb-n2 px-3 mt-3" v-if="selected.length > 0">
      <v-app-bar color="grey darken-3 mb-3" dense dark>
        <v-toolbar-title class="overline"
          >{{ selected.length }} selected</v-toolbar-title
        >
        <v-divider class="mx-4" vertical></v-divider>
        <v-btn
          depressed
          class="overline mx-4 custom-hover"
          color="grey darken-3"
          @click="edit()"
          >Edit</v-btn
        >
        <v-btn
          depressed
          class="overline mx-4 custom-hover"
          color="grey darken-3"
          @click="deleteCategory()"
          >Delete</v-btn
        >
      </v-app-bar>
    </v-row>
    <v-row class="mb-n7 mt-n3" v-show="showSuccessMessage">
      <v-col cols="12">
        <v-alert dense text type="success" dismissible
          >Created New Document Category</v-alert
        >
      </v-col>
    </v-row>
    <v-row class="mb-n7 mt-n3" v-show="showSuccess">
      <v-col cols="12">
        <v-alert dense text type="success" dismissible
          >Updated Document Category</v-alert
        >
      </v-col>
    </v-row>
    <v-row class="mt-1">
      <v-col>
        <v-data-table
          v-model="selected"
          :single-select="false"
          :items="allDocumentCategories"
          :headers="headers"
          :items-per-page="10"
          class="elevation-2"
          item-key="id"
          :search="search"
          show-select
          :loading="isFetching"
          loading-text="Loading... Please wait"
        >
        </v-data-table>
      </v-col>
    </v-row>
    <loading-overlay v-if="loading"/>
    <DocumentCategoryCreateDialog
      :dialog="dialog"
      :saveType="saveType"
      :categoryUpdate="categoryUpdate"
      @closeDialog="closeDialog"
    />
  </div>
</template>

<script>
  import Swal from "sweetalert2";
  import { mapActions, mapGetters } from "vuex";
  import DocumentCategoryCreateDialog from "./DocumentCategoryCreateDialog";
  import LoadingOverlay from "../common/LoadingOverlay.vue";

  export default {
    name: "DocumentCategoriesList",
    props: {
      tableDisplay: String,
      // search: String,
      isFetching: Boolean,
      dialog: Boolean,
    },
    components: {
      DocumentCategoryCreateDialog,
      LoadingOverlay
    },
    data() {
      return {
        loading: false,
        selected: [],
        headers: [
          { text: "Name", value: "name" },
          { text: "Group", value: "classification"},
          { text: "Created At", value: "createdAt" },
          { text: "Updated At", value: "updatedAt" },
        ],
        search: "",
        showSuccess: false,
        showSuccessMessage: false,
        categoryUpdate: null,
        saveType: "Create",
      };
    },
    methods: {
      ...mapActions(["fetchDocumentCategories", "deleteDocumentCategory"]),
      closeDialog(val, action) {
        this.$emit("closeDialog", false)
        // this.dialog = false;
        this.categoryUpdate = null;
        this.saveType = "Create";
        this.selected = [];
        // if (val) this.showSuccess = true;
        if(action == "Update"){
          this.showSuccess = true
          this.showSuccessMessage = false
        }else if(action == "Create"){
          this.showSuccess = false
          this.showSuccessMessage = true
        }else if(action == "Close"){
          this.showSuccess = false
          this.showSuccessMessage = false
        }
      },
      edit() {
        if (this.selected.length > 1)
          alert("Must select only one category to update");
        else {
          // this.dialog = true;
          this.$emit("openDialog", "categories")
          this.categoryUpdate = this.selected[0];
          this.saveType = "Update";
        }
      },
      deleteCategory() {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        }).then((result) => {
          const selectedItems = [];
          for (let i = 0; i < this.selected.length; i++) {
            selectedItems.push(this.selected[i].id);
          }
          if (result.isConfirmed) {
            this.loading = true;
            this.deleteDocumentCategory(selectedItems).then((res) => {
              if (res.error) {
                this.loading = false
                console.log(res);
                if (res.status === 403) {
                  Swal.fire({
                    icon: "error",
                    title: "Action Forbidden",
                    text:
                      "Cannot delete when a document is assigned with the selected categories",
                  });
                }
              } else {
                this.loading = false
                Swal.fire(
                  "Deleted!",
                  "Your file has been deleted.",
                  "success"
                );
              }
              this.selected = [];
            });
          }
        });
      }
    },
    computed: mapGetters(["allDocumentCategories"]),
    created() {
      this.fetchDocumentCategories();
    },
    watch: {
      tableDisplay() {
        if (this.tableDisplay !== "document_categories")
          this.showSuccess = false;
      },
    },
  };
</script>

<style></style>
